// Created by hejikun on 2017/11/2 0002.
let familyDoctor = [
  {
    path: '/family_doctor_index',
    name: '家庭医生',
    component: () => import('@/pages/familyDoctor/family_doctor_index')
  },
  {
    path: '/family_organization_index',
    name: '机构主页',
    component: () => import('@/pages/familyDoctor/family_organization_index')
  },
  {
    path: '/family_confirm_order',
    name: '病情信息',
    component: () => import('@/pages/familyDoctor/family_confirm_order')
  },
  {
    path: '/family_team_index',
    name: '团队主页',
    component: () => import('@/pages/familyDoctor/family_team_index')
  },
  {
    path: '/family_doctor_detail',
    name: '医生详情',
    component: () => import('@/pages/familyDoctor/family_doctor_detail')
  },
  {
    path: '/family_order_detail',
    name: '病情信息',
    component: () => import('@/pages/familyDoctor/family_order_detail')
  },
  {
    path: '/family_order_list',
    name: '订单列表',
    component: () => import('@/pages/familyDoctor/family_order_list')
  },
  {
    path: '/family_package_detail',
    name: '服务包详情',
    component: () => import('@/pages/familyDoctor/family_package_detail')
  },
  {
    path: '/family_packages_list',
    name: '更多服务包',
    component: () => import('@/pages/familyDoctor/family_packages_list')
  },
  {
    path: '/family_hospital',
    name: '专家预约',
    component: () => import('@/pages/familyDoctor/family_hospital')
  }
]

export default familyDoctor
